import { Box, Flex, Heading, Text, Button, VStack, Icon } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { FaExclamationTriangle } from 'react-icons/fa';

const Error500 = () => {
    const navigate = useNavigate();

    return (
        <Flex
            minH="100vh"
            align="center"
            justify="center"
            bg="gray.50"
            px={4}
        >
            <Box
                maxW="md"
                w="full"
                bg="white"
                shadow="none"
                rounded="lg"
                p={8}
                textAlign="center"
            >
                <VStack spacing={6}>
                    <Icon
                        as={FaExclamationTriangle as React.ElementType}
                        w={16}
                        h={16}
                        color="red.500"
                    />

                    <VStack spacing={2}>
                        <Heading size="2xl" color="gray.800">
                            500
                        </Heading>
                        <Heading size="lg" color="gray.700">
                            Internal Server Error
                        </Heading>
                        <Text color="gray.600" fontSize="md">
                            Something went wrong on our end. We're working to fix this issue.
                        </Text>
                    </VStack>

                    <VStack spacing={3} w="full">
                        <Button
                            colorScheme="blue"
                            size="lg"
                            w="full"
                            onClick={() => window.location.reload()}
                        >
                            Try Again
                        </Button>
                        <Button
                            variant="outline"
                            size="lg"
                            w="full"
                            onClick={() => navigate('/')}
                        >
                            Go to Dashboard
                        </Button>
                    </VStack>

                    <Text fontSize="sm" color="gray.500">
                        If the problem persists, please contact support.
                    </Text>
                </VStack>
            </Box>
        </Flex>
    );
};

export default Error500; 